import { InvoiceFee } from "../types/invoice";
import { getPercentFormat } from "./invoice";

const formatSpecialFee = (fee: InvoiceFee): string => {
  const isPercentType = [2, 4].includes(fee.feeTypeId);

  return `${isPercentType ? getPercentFormat(fee.fee) : ""}`;
};

export default formatSpecialFee;
